exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#topButton {\n  visibility: hidden;\n  position: fixed;\n  bottom: 1.2rem;\n  right: 1.5rem;\n  cursor: pointer;\n  padding: 15px;\n  outline: none;\n  border-radius: 2rem;\n  font-size: 1.5rem;\n}\n", ""]);

